<template>
    <el-tooltip placement="top" :content="localizedEnum" :open-delay="300">
        <i v-if="icon" class="fa font_lg enum_icon" :class="[icon, colorClass]" aria-hidden="true"></i>
		<span v-if="iconText" :class="cssClass">{{ iconText }}</span>
    </el-tooltip>
</template>

<script>
import {formatAsLocalizedEnum} from "@/common/format";

export default {
	data() {
		return {
			localizedEnum: "",
			icon: "fa-question",
			colorClass: "secondary_color",
			iconText: "",
			cssClass: ""
        }
    },
    beforeMount() {
        let enumDef = this.params.colDef.enumDef;
        let value = this.params.value;

        this.localizedEnum = formatAsLocalizedEnum(enumDef, value);

        if (enumDef.hasOwnProperty("properties") && enumDef.properties.hasOwnProperty(value)) {
            this.icon = enumDef.properties[value].icon;
			if (enumDef.properties[value].colorClass) {
				this.colorClass = enumDef.properties[value].colorClass;
			}

			this.iconText = enumDef.properties[value].iconText;
			this.cssClass = enumDef.properties[value].iconTextClass ?? enumDef.properties[value].cssClass;
        }
    }
};
</script>

<style lang="scss" scoped>
.enum_icon {
    line-height: 26px;
}
</style>
